import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";
import BannerImg from "../assets/Images/hkasharmony.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";
import "./SignTheCharterPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FormImg from "../assets/Images/smallimage.png";
import { useState } from "react";

const SignTheCharterPage = () => {
  const { t } = useTranslation();

  const [organizationNameChi, setorganizationNameChi] = useState("");
  const [organizationNameEng, setorganizationNameEng] = useState("");
  const [organizationNameAddress, setorganizationNameAddress] = useState("");
  const [contactPerson, setcontactPerson] = useState("");
  const [contactPersonPosition, setcontactPersonPosition] = useState("");
  const [contactPersonTele, setcontactPersonTele] = useState("");
  const [contactPersonEmail, setcontactPersonEmail] = useState("");

  let reset = async (e) => {
    e.preventDefault();
    setorganizationNameChi("");
    setorganizationNameEng("");
    setorganizationNameAddress("");
    setcontactPerson("");
    setcontactPersonPosition("");
    setcontactPersonTele("");
    setcontactPersonEmail("");
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let res = await fetch("https://www.hkarbsoc.org.hk:9000/sendemail/", {
        method: "POST",
        body: JSON.stringify({
          organizationNameChi,
          organizationNameEng,
          organizationNameAddress,
          contactPerson,
          contactPersonPosition,
          contactPersonTele,
          contactPersonEmail,
        }),
      });
      let resJson = await res.json();
      console.log(resJson);
      if (res.status === 200) {
        alert("Thank you");
      } else {
        alert("");
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">
            {t("sign_the_charter_page_header")}
          </h1>
          <p className="banner-subtitle">
            {t("sign_the_charter_page_header2")}
          </p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_sign_the_charter_page_link1")}</Link>
        <span>{t("breadcrumbs_sign_the_charter_page_span")}</span>
        <Link>{t("breadcrumbs_sign_the_charter_page_link2")}</Link>
      </Breadcrumbs>
      <main className="charter-main-container">
        <section className="charter-form-section">
          <header className="charter-form-header">
            <img src={FormImg} alt="Charter signing form" />
          </header>
          <div className="form-container">
            <form onSubmit={handleSubmit} className="charter-form">
              <input
                type="text"
                value={organizationNameChi}
                placeholder={t("sign_the_charter_page_text1a")}
                name="organizationNameChi"
                id="organizationNameChi"
                className="form-input"
                onChange={(e) => setorganizationNameChi(e.target.value)}
              />
              <input
                type="text"
                value={organizationNameEng}
                placeholder={t("sign_the_charter_page_text1b")}
                name="organizationNameEng"
                id="organizationNameEng"
                className="form-input"
                onChange={(e) => setorganizationNameEng(e.target.value)}
              />
              <textarea
                value={organizationNameAddress}
                placeholder={t("sign_the_charter_page_text1c")}
                name="organizationNameAddress"
                id="organizationNameAddress"
                className="form-textarea"
                onChange={(e) => setorganizationNameAddress(e.target.value)}
              ></textarea>
              <input
                type="text"
                value={contactPerson}
                placeholder={t("sign_the_charter_page_text1d")}
                name="contactPerson"
                id="contactPerson"
                className="form-input"
                onChange={(e) => setcontactPerson(e.target.value)}
              />
              <input
                type="text"
                value={contactPersonPosition}
                placeholder={t("sign_the_charter_page_text1e")}
                name="contactPersonPosition"
                id="contactPersonPosition"
                className="form-input"
                onChange={(e) => setcontactPersonPosition(e.target.value)}
              />
              <input
                type="tel"
                value={contactPersonTele}
                placeholder={t("sign_the_charter_page_text1f")}
                name="contactPersonTele"
                id="contactPersonTele"
                className="form-input"
                onChange={(e) => setcontactPersonTele(e.target.value)}
              />
              <input
                type="email"
                value={contactPersonEmail}
                placeholder={t("sign_the_charter_page_text1g")}
                name="contactPersonEmail"
                id="contactPersonEmail"
                className="form-input"
                onChange={(e) => setcontactPersonEmail(e.target.value)}
              />
              <ol type="1" className="charter-list">
                <li>
                  <p>{t("sign_the_charter_page_text1")}</p>
                </li>
                <li>
                  <p>{t("sign_the_charter_page_text2")}</p>
                </li>
                <li>
                  <p>{t("sign_the_charter_page_text3")}</p>
                </li>
                <li>
                  <p>{t("sign_the_charter_page_text4")}</p>
                </li>
              </ol>
              <div className="btns">
                <button onClick={reset}>
                  {t("sign_the_charter_page_button_text1")}
                </button>
                <button type="submit">
                  {t("sign_the_charter_page_button_text2")}
                </button>
              </div>
            </form>
          </div>
        </section>
      </main>
      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>

      <Footer />
    </>
  );
};

export default SignTheCharterPage;
